module.exports = "<section layout=column> <div class=md-subhead> Available folders<span ng-if=$ctrl.selectedItems.length>: <a href=# ng-click=\"$event.preventDefault(); $ctrl.showSelectedFolders();\">{{ $ctrl.selectedItems.length }} selected</a> <md-icon style=cursor:pointer ng-click=$ctrl.unselectFolders()>clear</md-icon> </span> </div> <dt-folder-selector multi-select=true fs-model=$ctrl.folderModel expand-selected=$ctrl.triggerExpansionOfSelected on-change=$ctrl.folderModelChanged($event)></dt-folder-selector> </section>";


//////////////////
// WEBPACK FOOTER
// ./app/components/sensors-and-connectors/components/search/advanced/thing-folders/thing-folders.html
// module id = mFMv
// module chunks = 1